import { onDomReady } from 'Shared/utils/dom-ready';

onDomReady(() => {
   document.querySelectorAll('.keyboard-shortcuts').forEach(el => {
      el.addEventListener('click', () => {
         import('Shared/modal').then(({ Modal }) => {
            Modal.open({
               type: 'element',
               element: document.querySelector('#shortcuts-modal'),
            });
         });
      });
   });
});
